import { APPS_HOME_PATH } from "@/lib/apps";

export interface OrgBackLink {
  to: string;
  label: string;
}

export function resolveOrgBackLink(pathname: string): OrgBackLink {
  const userDetailMatch = pathname.match(/^\/users\/([^/]+)/);
  if (userDetailMatch) {
    return { to: "/users", label: "Back to users" };
  }

  if (pathname === "/users" || pathname === "/users/") {
    return { to: APPS_HOME_PATH, label: "Back to apps" };
  }

  if (
    pathname === "/organization/integrations" ||
    pathname === "/organization/integrations/"
  ) {
    return { to: APPS_HOME_PATH, label: "Back to apps" };
  }

  if (pathname === "/organization/roles" || pathname === "/organization/roles/") {
    return { to: APPS_HOME_PATH, label: "Back to apps" };
  }

  return { to: APPS_HOME_PATH, label: "Back to apps" };
}
